import { render, staticRenderFns } from "./Belgium.vue?vue&type=template&id=02789b8a&"
import script from "./Belgium.vue?vue&type=script&lang=js&"
export * from "./Belgium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02789b8a')) {
      api.createRecord('02789b8a', component.options)
    } else {
      api.reload('02789b8a', component.options)
    }
    module.hot.accept("./Belgium.vue?vue&type=template&id=02789b8a&", function () {
      api.rerender('02789b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Belgium.vue"
export default component.exports